<!-- Footer X-Large Screen -->
<div class="d-none d-xl-block align-center">
  <div class="row flex-column">
    <div class="d-flex justify-content-start">
      <app-footer-lower [sizeClass]="'footerTextXl'"></app-footer-lower>
    </div>
  </div>
</div>

<!-- Footer Large Screen -->
<div class="d-none d-lg-block d-xl-none align-center">
  <div class="row flex-column">
    <div class="d-flex justify-content-start">
      <app-footer-lower [sizeClass]="'footerTextLg'"></app-footer-lower>
    </div>
  </div>
</div>

<!-- Footer Medium Screen -->
<div class="d-none d-md-block d-lg-none align-center">
  <div class="row flex-column">
    <div class="d-flex justify-content-start">
      <app-footer-lower [sizeClass]="'footerTextLg'"></app-footer-lower>
    </div>
  </div>
</div>

<!-- Footer Small Screen -->
<div class="d-none d-sm-block d-md-none align-center">
  <div class="row flex-column">
    <div class="d-flex justify-content-start">
      <app-footer-lower [sizeClass]="'footerTextSm'"></app-footer-lower>
    </div>
  </div>
</div>

<!-- Footer X-Small Screen -->
<div class="d-block d-sm-none">
  <div class="row flex-column align-items-start">
    <div class="d-flex flex-column align-center">
      <app-footer-lower [sizeClass]="'footerTextXs'"></app-footer-lower>
    </div>
  </div>
</div>